<template>
  <div v-if="showSidePanel" class="side-panel bg-white pa-8"
          style="z-index: 999;">
    <div class="side-panel__header d-flex flex-row justify-space-between">
      <h5 class="text-gray">{{ label }}</h5>
      <v-icon @click.stop="close()">mdi-close</v-icon>
    </div>
    <v-divider class="mb-0"></v-divider>
    <div class="side-panel__svg-container">
      <svg width="47" height="19" viewBox="0 0 47 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 19C1.79086 19 -8.09029e-08 17.2091 -1.80702e-07 15L-8.58333e-07 1.90735e-06L47 -8.05075e-08L47 15C47 17.2091 45.2091 19 43 19L4 19Z" fill="#EBEBEB"/>
        <circle cx="37.5" cy="9.5" r="5.5" transform="rotate(-90 37.5 9.5)" :fill="getTrafficGreen(score)"/>
        <circle cx="23.5" cy="9.5" r="5.5" transform="rotate(-90 23.5 9.5)" :fill="getTrafficYellow(score)"/>
        <circle cx="9.5" cy="9.5" r="5.5" transform="rotate(-90 9.5 9.5)" :fill="getTrafficRed(score)"/>
      </svg>
    </div>
    <div class="side-panel__infos d-flex flex-row">
      <span class="numeric mx-8 my-3" style="font-size: 64px; color: var(--gray-color); line-height: 3rem;">{{score
        }}</span>
      <div class="side-panel__infos my-3">
                            <span class="side-panel__infos__date text-gray">{{
                                timeConverter(timestamp)}}</span>
        <div class="side-panel__infos__trend d-flex align-center">
          <v-chip label :color="getTrendColor(getTrend(ev, index))+'_s'"
                  :text-color="getTrendColor(getTrend(ev, index))">

                            <span v-if="getTrend(ev, index) != 0"
                                  class="numeric font-l font-weight-bold"> {{ getTrend(ev, index) }}
                      </span>
            <v-icon medium>{{ getTrendIcon(getTrend(ev, index)) }}</v-icon>
          </v-chip>
          <span style="font-size: 12px;" class="ml-2"
                :class="getTrend(ev, index) == 0 ? 'text--disabled' : 'text--secondary'">{{
              getTrendText(getTrend(ev,
                  index))
            }}</span>
          <div v-if="getTrend(ev, index) <= -1" class="ml-2">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.3998 20.0625L12.6498 3.1875C12.5045 2.93672 12.2537 2.8125 12.0006 2.8125C11.7475 2.8125 11.4943 2.93672 11.3514 3.1875L1.60138 20.0625C1.31309 20.5641 1.67403 21.1875 2.25059 21.1875H21.7506C22.3272 21.1875 22.6881 20.5641 22.3998 20.0625ZM11.2506 9.75C11.2506 9.64687 11.335 9.5625 11.4381 9.5625H12.5631C12.6662 9.5625 12.7506 9.64687 12.7506 9.75V14.0625C12.7506 14.1656 12.6662 14.25 12.5631 14.25H11.4381C11.335 14.25 11.2506 14.1656 11.2506 14.0625V9.75ZM12.0006 18C11.7062 17.994 11.4259 17.8728 11.2198 17.6625C11.0137 17.4522 10.8983 17.1695 10.8983 16.875C10.8983 16.5805 11.0137 16.2978 11.2198 16.0875C11.4259 15.8772 11.7062 15.756 12.0006 15.75C12.295 15.756 12.5753 15.8772 12.7814 16.0875C12.9874 16.2978 13.1029 16.5805 13.1029 16.875C13.1029 17.1695 12.9874 17.4522 12.7814 17.6625C12.5753 17.8728 12.295 17.994 12.0006 18Z" fill="#ED484F"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="side-panel__chart-container">
      <span class="text-md-subtitle-2">Zeitlicher Verlauf</span>
      <div class="side-panel__chart">
        <v-row class="mt-2">
          <LineChart :data="getEvaluationsForTrend(ev,index)"/>
        </v-row>

      </div>
    </div>
    <v-divider></v-divider>
    <div class="side-panel__tree">
      <span class="text-md-subtitle-2">Veränderung der Unterkategorien</span>
      <!-- <v-card flat class="bg-gray pa-4 mt-4">
        <div class="side-panel__tree__title full-width d-flex justify-space-between">
          <div>
            <v-chip small class="mr-2 px-2" label color="tr_yellow" text-color="white">
              <span class="text-md-subtitle-2">3</span>
            </v-chip>
            <span class="text-md-body-1 text-gray">Flexibität</span>
          </div>
          <v-chip small label color="tr_red_s" text-color="tr_red" class="px-2">
            -
            <span class="numeric font-l font-weight-bold">
                          1
                        </span>
            <v-icon small color="tr_red">mdi-trending-down</v-icon>
          </v-chip>
        </div>
        <v-card flat class="bg-white d-flex justify-space-between my-3 full-width align-center" height="36">
          <div class="">
            <v-chip color="white" text-color="tr_yellow">2</v-chip>
            <span style="line-height: 36px;">Vorhersehbarkeit</span>
          </div>
          <v-chip label small color="white" text-color="tr_red" class="px-2 pl-0 mr-2">
            <v-icon>mdi-triangle-small-down</v-icon>
            <span class="text--accent-4">1</span>
          </v-chip>
        </v-card>
      </v-card> -->
    </div>
  </div>
</template>

<script>
import LineChart from './Charts/LineChart.vue';

export default {
  name: "PXSurveyEvaluationTrendDetail",
  components: {
    LineChart,
  },
  props: [ 'ev', 'index', 'label', 'score', 'timestamp', 'currentEvaluation',
    'timeConverter',
    'getTrend', 'getTrendColor', 'getTrendIcon', 'getTrendText', 'getEvaluationsForTrend' ],
  data() {
    return {
      showSidePanel: false,
    }
  },
  methods: {
    open() {
      this.showSidePanel = true;
    },
    close() {
      this.showSidePanel = false;
    },
    getTrafficGreen(score) {
      if(score <= 2) return 'var(--green-color)';
      return '#D5D5D5';
    },
    getTrafficYellow(score) {
      if(score > 2 && score <= 4) return 'var(--yellow-color)';
      return '#D5D5D5';
    },
    getTrafficRed(score) {
      if(score >= 5) return 'var(--red-color)';
      return '#D5D5D5';
    },
  },
}
</script>

<style scoped>
.side-panel {
  position: fixed;
  width: 34vw;
  height: calc(100vh - 52px);
  right: 0;
  top: 52px;
  bottom: 0;
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.12);
  overflow: auto;
}
.side-panel__infos__date {
  font-size: 10px;
}
</style>